import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

export const testRoutes: RouteObject = {
  path: 'test',
  children: [
    {
      index: true,
      element: <Navigate to="/subcategory-list" replace />
    },
    {
      path: 'subcategory-list',
      lazy: async () => {
        const module = await import('@/pages/test/SubcategoryListTestPage')
        return {
          element: <module.SubcategoryListTestPage />
        }
      }
    },
    {
      path: 'technology-list',
      lazy: async () => {
        const module = await import('@/pages/test/TechnologyListTestPage')
        return {
          element: <module.TechnologyListTestPage />
        }
      }
    },
    {
      path: 'project-list',
      lazy: async () => {
        const module = await import('@/pages/test/ProjectListTestPage')
        return {
          element: <module.ProjectListTestPage />
        }
      }
    },
    {
      path: 'service-list',
      lazy: async () => {
        const module = await import('@/pages/test/ServiceListTestPage')
        return {
          element: <module.ServiceListTestPage />
        }
      }
    },
    {
      path: 'control-objective-list',
      lazy: async () => {
        const module = await import('@/pages/test/ControlObjectiveListTestPage')
        return {
          element: <module.ControlObjectiveListTestPage />
        }
      }
    },
    {
      path: 'subcategory-recomendation-form',
      lazy: async () => {
        const module = await import('@/pages/test/SubcategoryRecomendationFormTestPage')
        return {
          element: <module.SubcategoryRecomendationFormTestPage />
        }
      }
    },
    {
      path: 'assessments-list',
      lazy: async () => {
        const module = await import('@/pages/test/AssessmentsListTestPage')
        return {
          element: <module.AssessmentsListTestPage />
        }
      }
    },
    {
      path: 'framework-version-list',
      lazy: async () => {
        const module = await import('@/pages/test/FrameworkVersionListTestPage')
        return {
          element: <module.FrameworkVersionListTestPage />
        }
      }
    },
    {
      path: 'assessment-form',
      lazy: async () => {
        const module = await import('@/pages/test/AssessmentFormTestPage')
        return {
          Component: module.default
        }
      }
    },
    {
      path: 'assessment-card',
      lazy: async () => {
        const module = await import('@/pages/test/AssessmentCardTestPage')
        return {
          Component: module.default
        }
      }
    }
  ]
}
